import React from 'react'
import '../Biochemistry/Biochemistry.css'
import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'
import Rifat_cv from '../../../assets/CVs/Biochemistry/Rifat Jahan.pdf'
import Bushra_cv from '../../../assets/CVs/Biochemistry/Dr. bushra Ahmad updated Curiiculum Vitea.pdf'
import Sidra_CV from '../../../assets/CVs/Biochemistry/Sidra CV.pdf'
import Footer from '../../../Components/Footer'
import TeacherCard from '../../../Components/TeacherCard'

const Biochemistry = () => {
  return (
    <>
    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Biochemistry</h2>
        
        <p className='dep_intro'>
          Faculty of Biochemistry .</p>
      </div>

      <div className="row">

  

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid img-thumbnail" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Bushra Ahmad</h4>
              <span>Assistant Professor Department of Biochemistry</span>
              <p>Incharge Department of Biochemistry Shaheed Benazir Bhutto Women University  Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>  : bushraahmad@sbbwu.edu.pk </p>
              <div className="social">
                <a href={Bushra_cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
                
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6"> 
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid img-thumbnail" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Sidra Pervez</h4>
              <span>Assistant Professor Department of Biochemistry</span>              
              <p>HEC approved supervisor Department
                 of Biochemistry, Shaheed Benazir Bhutto Women University Peshawar</p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>  : drsidrapervez@sbbwu.edu.pk </p>
              <div className="social">
                <a href={Sidra_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=" https://scholar.google.com/citations?hl=en&user=ROMlGDQAAAAJ"><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid img-thumbnail" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Rifat </h4>
              <span>lecturer Department of Biochemistry</span>
              
              <p>Working as lecturer in Department of Biochemistry, 
                 Benazir Bhutto Women Universit Peshawar  </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> :  rifatchem@sbbwu.edu.pk </p>
              
              <div className="social">
           
                <a href={Rifat_cv}> <i class="bi bi-file-earmark-person-fill"></i></a>
                <a href="https://scholar.google.com/citations?hl=en"><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>

 
       
       
        
        

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>
    </>
  )
}

export default Biochemistry
